export default __webpack_public_path__ + "static/media/gallery_00.09c500b5.jpg";